<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					text: {
						name: 'text',
						defaultValue: '',
						labelDesc: 'text',
						canRemove: false,
						callback: function () {
							vm.resources.text.defaultValue = this.value;
							vm.element.internal_config.text = this.value;

							vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;
						},
					},
					subtext: {
						name: 'subtext',
						defaultValue: '',
						labelDesc: 'subtext',
						canRemove: false,
						callback: function () {
							vm.resources.subtext.defaultValue = this.value;
							vm.element.internal_config.subtext = this.value;

							vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColor = this.colorValue;
						},
					},
					backgroundColorHover: {
						name: 'backgroundColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color-hover',
						callback: function () {
							vm.resources.backgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColorHover = this.colorValue;
						},
					},
					src: {
						name: 'src',
						defaultValue: '',
						labelDesc: 'bg-image',
						canRemove: true,
						callback: function () {
							vm.resources.src.defaultValue = this.value;
							vm.element.internal_config.backgroundImage = this.value;

							//force apply new bg
							let color = vm.element.internal_config.backgroundColor;
							vm.element.internal_config.backgroundColor = '#FFFFFF';
							vm.element.internal_config.backgroundColor = color;
						},
					},
					backgroundConfig: {
						name: 'backgroundConfig',
						defaultValueOrigin: '',
						defaultValueSize: '',
						defaultValueRepeat: '',
						labelDesc: 'backgroundConfig',
						canRemove: true,
						callback: function () {
							vm.resources.backgroundConfig.defaultValueOrigin = this.origin;
							vm.resources.backgroundConfig.defaultValueRepeat = this.repeat;
							vm.resources.backgroundConfig.defaultValueSize = this.size;

							vm.element.internal_config.backgroundOrigin = this.origin;
							vm.element.internal_config.backgroundRepeat = this.repeat;
							vm.element.internal_config.backgroundSize = this.size;

							//force apply new bg
							let color = vm.element.internal_config.backgroundColor;
							vm.element.internal_config.backgroundColor = '#FFFFFF';
							vm.element.internal_config.backgroundColor = color;
						},
					},
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
					icon: {
						name: 'icon',
						defaultIcon: '',
						defaultPosition: 'left',
						labelDesc: 'icon',
						callback: function () {

							vm.resources.icon.defaultIcon = this.iconSelected;
							vm.resources.icon.defaultPosition = this.position;

							vm.element.internal_config.icon = this.iconSelected;
							vm.element.internal_config.iconPosition = this.position;

							vm.element.buildIcon();
						},
					},
					textStyle: {
						name: 'textStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						defaultWeight: '',
						defaultStyle: '',
						labelDesc: 'textStyle',
						callback: function () {

							vm.resources.textStyle.defaultFamily = this.family;
							vm.element.internal_config.textStyle.family = this.family;

							vm.resources.textStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.textStyle.size = this.size + 'px';

							vm.resources.textStyle.defaultColor = this.color;
							vm.element.internal_config.textStyle.color = this.color;

							vm.resources.textStyle.defaultAlign = this.align;
							vm.element.internal_config.textStyle.align = this.align;

							vm.resources.textStyle.defaultWeight = this.weight;
							vm.element.internal_config.textStyle.weight = this.weight;

							vm.resources.textStyle.defaultStyle = this.style;
							vm.element.internal_config.textStyle.style = this.style;

						},
					},
					subTextStyle: {
						name: 'subTextStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						labelDesc: 'subTextStyle',
						callback: function () {

							vm.resources.subTextStyle.defaultFamily = this.family;
							vm.element.internal_config.subTextStyle.family = this.family;

							vm.resources.subTextStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.subTextStyle.size = this.size + 'px';

							vm.resources.subTextStyle.defaultColor = this.color;
							vm.element.internal_config.subTextStyle.color = this.color;

							vm.resources.subTextStyle.defaultAlign = this.align;
							vm.element.internal_config.subTextStyle.align = this.align;

							vm.resources.subTextStyle.defaultWeight = this.weight;
							vm.element.internal_config.subTextStyle.weight = this.weight;

							vm.resources.subTextStyle.defaultStyle = this.style;
							vm.element.internal_config.subTextStyle.style = this.style;

						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '50',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;

				// this.resources.width.defaultValue = parseInt(data.internal_config.width);
				// this.resources.height.defaultValue = parseInt(data.internal_config.height);

				this.resources.text.defaultValue = data.internal_config.text;
				this.resources.subtext.defaultValue = data.internal_config.subtext;

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

				this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
				this.resources.backgroundColorHover.defaultValue = data.internal_config.backgroundColorHover;
				this.resources.src.defaultValue = data.internal_config.backgroundImage;
				this.resources.backgroundConfig.defaultValueOrigin = data.internal_config.backgroundOrigin;
				this.resources.backgroundConfig.defaultValueRepeat = data.internal_config.backgroundRepeat;
				this.resources.backgroundConfig.defaultValueSize = data.internal_config.backgroundSize;

				this.resources.textStyle.defaultFamily = data.internal_config.textStyle.family;
				this.resources.textStyle.defaultSize = data.internal_config.textStyle.size;
				this.resources.textStyle.defaultColor = data.internal_config.textStyle.color;
				this.resources.textStyle.defaultAlign = data.internal_config.textStyle.align;
				this.resources.textStyle.defaultWeight = data.internal_config.textStyle.weight;
				this.resources.textStyle.defaultStyle = data.internal_config.textStyle.style;

				this.resources.subTextStyle.defaultFamily = data.internal_config.subTextStyle.family;
				this.resources.subTextStyle.defaultSize = data.internal_config.subTextStyle.size;
				this.resources.subTextStyle.defaultColor = data.internal_config.subTextStyle.color;
				this.resources.subTextStyle.defaultAlign = data.internal_config.subTextStyle.align;
				this.resources.subTextStyle.defaultWeight = data.internal_config.subTextStyle.weight;
				this.resources.subTextStyle.defaultStyle = data.internal_config.subTextStyle.style;

				this.resources.icon.defaultIcon = data.internal_config.icon;
				this.resources.icon.defaultPosition = data.internal_config.iconPosition;

		  this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
		  this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
		  this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
		  this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>
